// API 기본 설정
export const API_BASE_URL = '/api';

// 공통 fetch 함수 (쿠키 기반 인증)
export async function apiFetch(url, options = {}) {
  try {
    const response = await fetch(`${API_BASE_URL}${url}`, {
      credentials: 'same-origin',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    // 401 에러 시 로그아웃 처리 (SPA 방식)
    if (response.status === 401) {
      window.dispatchEvent(new CustomEvent('auth:logout'));
      throw new Error('인증이 만료되었습니다. 다시 로그인해주세요.');
    }

    const data = await response.json();

    // ApiResponse 구조에 맞게 처리
    if (data.success) {
      return data;
    } else {
      throw new Error(data.message || '요청 실패');
    }
  } catch (error) {
    console.error('API 호출 오류:', error);
    throw error;
  }
}

// R-16: FormData 업로드 공통 래퍼
export async function apiFetchFormData(url, file, method = 'POST') {
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(`${API_BASE_URL}${url}`, {
    method,
    credentials: 'same-origin',
    body: formData,
  });

  const data = await response.json();
  if (data.success) return data;
  throw new Error(data.message || '업로드 실패');
}
